var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3093 1.11198C10.7156 0.796007 11.2844 0.796007 11.6907 1.11198L20.6907 8.11198C20.9647 8.32512 21.125 8.65284 21.125 9V20C21.125 20.8288 20.7958 21.6237 20.2097 22.2097C19.6237 22.7958 18.8288 23.125 18 23.125H4C3.1712 23.125 2.37634 22.7958 1.79029 22.2097C1.20424 21.6237 0.875 20.8288 0.875 20V9C0.875 8.65284 1.03528 8.32512 1.30932 8.11198L10.3093 1.11198ZM3.125 9.55022V20C3.125 20.2321 3.21719 20.4546 3.38128 20.6187C3.54538 20.7828 3.76794 20.875 4 20.875H18C18.2321 20.875 18.4546 20.7828 18.6187 20.6187C18.7828 20.4546 18.875 20.2321 18.875 20V9.55022L11 3.42522L3.125 9.55022Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 12C6.875 11.3787 7.37868 10.875 8 10.875H14C14.6213 10.875 15.125 11.3787 15.125 12V22C15.125 22.6213 14.6213 23.125 14 23.125C13.3787 23.125 12.875 22.6213 12.875 22V13.125H9.125V22C9.125 22.6213 8.62132 23.125 8 23.125C7.37868 23.125 6.875 22.6213 6.875 22V12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3b4364c128fccf37f9e70e225e00ebd0.svg";
export { ForwardRef as ReactComponent };